import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Contact";
import { RegHero } from "@/components/reg/RegHero";
import { Categories } from "@/components/reg/Categories";
import { RegProcess } from "@/components/reg/RegProcess";
import { Roadmap } from "@/components/reg/Roadmap";
import { SmartCheck } from "@/components/reg/SmartCheck";
import { Documents } from "@/components/reg/Documents";
import { WhyLaunchLab } from "@/components/reg/WhyLaunchLab";
import { RegClosing } from "@/components/reg/RegClosing";

export default function Registrations() {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    api.get("/settings").then((r) => setSettings(r.data)).catch(() => setSettings({}));
  }, []);

  return (
    <div data-testid="registrations-page" className="relative w-full max-w-[100vw] overflow-x-clip text-slate-100">
      <Header />
      <main>
        <RegHero />
        <Categories />
        <RegProcess />
        <Roadmap />
        <SmartCheck />
        <Documents />
        <WhyLaunchLab />
        <RegClosing settings={settings} />
      </main>
      <Footer settings={settings} />
    </div>
  );
}
